import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import backArrow from '../../../../images/dark-left-arrow.svg';
import { StyledLink } from '../../Blog/Articles/Header/styles';

import { Wrapper, StyledContainer, Name, Title, ProfileImage } from './styles';

const Profile = ({ sectionId, data, className }) => {
  if (!data) return null;
  const {
    imageSharp,
    image,
    name,
    title,
    descriptionHtml,
    backButtonText,
    backButtonLink,
  } = data;

  return (
    <Wrapper id={sectionId} className={className}>
      <StyledContainer className="auto-margin">
        <ProfileImage
          src={imageSharp || image.url}
          alt={
            imageSharp && imageSharp.altTag ? imageSharp.altTag : image.altTag
          }
        />
        <Name>{name && name[0].text}</Name>
        <Title>{title && title[0].text}</Title>
        {ReactHtmlParser(descriptionHtml)}
        {backButtonText && backButtonLink && (
          <StyledLink to={backButtonLink.url} img={backArrow}>
            {backButtonText}
          </StyledLink>
        )}
      </StyledContainer>
    </Wrapper>
  );
};

Profile.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
  sectionId: PropTypes.string.isRequired,
};

Profile.defaultProps = {
  className: null,
};

export default Profile;
